module.exports = __webpack_public_path__ + "apple-icon-114x114.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./app/images/apple-icon-114x114.png
// module id = ./node_modules/file-loader/index.js?name=[name].[ext]!./app/images/apple-icon-114x114.png
// module chunks = 3